import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import { API_ENDPOINTS, COOKIES_KEY, FILE_KEYS } from '../Utils/constants'
import { COOKIE_STOAGE } from '../Utils/Storage'

export default class StaticItemsStore extends FetchBase {
  @observable deviceToken = undefined

  @observable documentTypes = []

  @action.bound
  setDeviceToken = async (deviceToken) => {
    if (deviceToken) {
      try {
        let response = await this.post(API_ENDPOINTS.ADD_DEVICE_TOKEN, {
          deviceToken,
        })
        if (response.status) {
          this.deviceToken = deviceToken
          COOKIE_STOAGE.setItem(COOKIES_KEY.DEVICE_TOKEN, deviceToken)
          return [true, response?.data]
        }
        return [false, undefined]
      } catch (error) {
        return [false, undefined]
      }
    }
  }

  @action.bound
  removeDeviceToken = async () => {
    if (this.deviceToken) {
      try {
        let response = await this.post(API_ENDPOINTS.DELETE_DEVICE_TOKEN, {
          deviceToken: this.deviceToken,
        })
        if (response.status) {
          this.deviceToken = undefined
          COOKIE_STOAGE.removeItem(COOKIES_KEY.DEVICE_TOKEN)
          return [true, response?.data]
        }
        return [false, undefined]
      } catch (error) {
        return [false, undefined]
      }
    } else {
      if (COOKIE_STOAGE.getItem(COOKIES_KEY.DEVICE_TOKEN)) {
        try {
          let response = await this.post(API_ENDPOINTS.DELETE_DEVICE_TOKEN, {
            deviceToken: COOKIE_STOAGE.getItem(COOKIES_KEY.DEVICE_TOKEN),
          })
          if (response.status) {
            this.deviceToken = undefined
            COOKIE_STOAGE.removeItem(COOKIES_KEY.DEVICE_TOKEN)
            return [true, response?.data]
          }
          return [false, undefined]
        } catch (error) {
          return [false, undefined]
        }
      }
      return [true, undefined]
    }
  }

  @observable
  getAllDocumentTypes = async () => {
    try {
      let response = await Promise.resolve(
        (FILE_KEYS || []).map((fileType) => {
          return {
            id: (fileType || '')?.toLowerCase() || '-',
            name: fileType || '-',
          }
        })
      )
      this.documentTypes = response
      return [true, response]
    } catch (err) {
      return [false, undefined]
    }
  }

  @observable
  checkIfEmailExist = async (email, editUserId) => {
    if (!email) {
      return true
    }
    try {
      let response = await this.post(API_ENDPOINTS.CHECK_EMAIL, {
        newEmail: email,
        editUser: Boolean(editUserId),
      })
      if (response.status) {
        return response?.data?.emailExists
      }
      return true
    } catch (err) {
      console.log(err)
      return true
    }
  }

  @observable
  checkIfEmailExistForOrg = async (email, editUserId) => {
    if (!email) {
      return true
    }
    try {
      let response = await this.post(API_ENDPOINTS.CHECK_EMAIL_EXISTS_FOR_ORG, {
        newEmail: email,
      })
      if (response.status) {
        return response?.data?.emailExists
      }
      return true
    } catch (err) {
      console.log(err)
      return true
    }
  }
}
